export const GET_VIEWINGS_WIDGET_STATISTICS = 'VIEWINGS_WIDGET_STATISTICS/GET_VIEWINGS_WIDGET_STATISTICS'
export const GET_VIEWINGS_WIDGET_STATISTICS_FAILED = 'VIEWINGS_WIDGET_STATISTICS/GET_VIEWINGS_WIDGET_STATISTICS_FAILED'
// eslint-disable-next-line max-len
export const GET_VIEWINGS_WIDGET_STATISTICS_SUCCESS = 'VIEWINGS_WIDGET_STATISTICS/GET_VIEWINGS_WIDGET_STATISTICS_SUCCESS'

export const CLEAR_VIEWINGS_WIDGET_STATISTICS = 'VIEWINGS_WIDGET_STATISTICS/CLEAR_VIEWINGS_WIDGET_STATISTICS'
